export default "__VITE_ASSET__2f5c7d2d__"